import { stringify } from 'src/core/hooks/use-translation'
import { boolean, number, object, setLocale, string } from 'yup'

setLocale({
  mixed: {
    required: 'common.required',
    notType: 'common.required',
    default: 'common.required'
  }
})

export default object().shape({
  // assign_tree_id: string().notRequired(),
  assign_tree_name: string()
    .required()
    .max(
      250,
      stringify('web.setup.form.field-title.max-character-error', {
        value: 250
      })
    ),
  chained: boolean().notRequired(),
  code: string()
    .notRequired()
    .max(
      250,
      stringify('web.setup.form.field-title.max-character-error', {
        value: 250
      })
    ),
  heritable_properties: boolean().notRequired(),
  p_assign_tree_type: string().required(),
  parent_id: number().required(),
  parent_name: string().notRequired()
})
